import { render, staticRenderFns } from "./areaMultiSelect.vue?vue&type=template&id=46b53619&scoped=true&"
import script from "./areaMultiSelect.vue?vue&type=script&lang=js&"
export * from "./areaMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b53619",
  null
  
)

export default component.exports